import styled from "styled-components/macro";
import {DefaultFont} from "../../../styles/fonts";

export const DataGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  border-radius: 8px;
  background-color: #FFF7F3;
  min-width: 22rem;
  & > div:nth-child(2n + 1) {
    border-right: 2px white solid;
  }
  & > div:nth-child(-n+2) {
    border-bottom: 2px white solid;
  }
  & > div {
    padding: 1em;
    
    & > h2 {
      margin-bottom: 0;
    };
    & > p {
      margin-bottom: 0;
      color: ${props => props.theme.text.color.orange};
      font-size: ${props => props.theme.text.default.mobileSize};
    };
  }
`;

export const ConceptCard = styled.div`
  ${DefaultFont};
  border-radius: 8px;
  background-color: #FFF7F3;
  padding: 1em;
  min-width: 15rem;
  align-self: stretch;
  white-space: nowrap;
  & > div:first-child {
    border-radius: 6px;
    display: inline-block;
    ${DefaultFont};
    width: 2em;
    line-height: 2em;
    margin-right: 1em;
    text-align: center;
    aspect-ratio: 1/1;
    color: white;
    background-color: ${props => props.theme.colors.text};
  }
  
  & > p {
    white-space: normal;
    margin-top: 1em;
    margin-bottom: 0;
  }
`;

export const ContactForm = styled.form`
  max-width: 40em;
  min-width: 20em;
  background-color: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 2em;
  
  & > div > div > input {
    border: 0;
    font-size: 18px;
    background-color: ${props => props.theme.colors.bgSecondary};
    
  }
  
  & > div {
    margin-bottom: 1.5em;
  }
  
  & > h2 {
    ${DefaultFont};
    font-size: 24px;
    font-weight: 500;
    margin-bottom: 1em;
    @media ${(props) => props.theme.media.phone} {
      font-size: 24px;
      font-weight: 500;
    }
  }

  & > p {
    ${DefaultFont};
    margin-bottom: 0.2em;
    font-size: 18px;
    font-weight: 500;
    @media ${(props) => props.theme.media.phone} {
      font-size: 18px;
      font-weight: 500;
    }
  }
`;

export const ContactSection = styled.div`
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  background-color: ${props => props.theme.colors.bgSecondary};
  padding: 2em 30% 2em 30%;
  margin-bottom: 0;
  
  @media ${(props) => props.theme.media.tablet} {
    padding: 2em 10% 2em 10%;
  }
  @media ${(props) => props.theme.media.phone} {
    padding: 2em 1em 2em 1em;
  }
`;
